import { PastDraw } from "@/lotteries/model/draw-info/past-draw";
import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { fetchDrawList } from "@/lotteries/services/draw-info/api";
import { ref } from "vue";

const pastDraws = ref<PastDraw[]>([]);
let promise = null as Promise<PastDraw[]> | null;

export const usePastDraws = () => {
    const fetchPastDraws = async (lottery: Lottery, refetch = false) => {
        if (!refetch && pastDraws.value.length > 0) {
            return;
        }

        if (promise) {
            await promise;
        }

        try {
            promise = fetchDrawList(lottery);
            pastDraws.value = await promise;
        } finally {
            promise = null;
        }
    };

    return {
        pastDraws,
        fetchPastDraws,
    };
};
